<template>
  <v-col cols="12"
         style="max-width: 1185px"
         class="mx-auto">
    <v-row class="mb-5">
      <v-col cols="12"
             sm="2"
             v-for="item in collections"
             :key="item.idTipopublicacao">
        <v-card @click="onSidebarFilter({idTipoPublicacao: item.idTipopublicacao});"
                class="cursor">
          <v-img gradient="to bottom, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                 :src="require(`@/assets/${item.etapas}.jpg`)"
                 class="align-center justify-center text-center"
                 max-height="300">
            <span class="subtitle-1 font-weight-bold white--text">{{ item.tipoPublicacao }}</span>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="hasPermission">
      <p><i>Faça uma busca e visualize os arquivos do acervo</i></p>
    </div>
    <div v-else>
      <p>
        <i>
          O Acervo Histórico reúne documentos textuais, fotográficos, audiovisuais,
          de referência, peças tridimensionais, e depoimentos sobre a trajetória da Wilson
          Sons, que está presente no Brasil há mais de 180 anos.
        </i>
      </p>
      <p>
        <i><strong>Atendimento: centro.memoria@wilsonsons.com.br</strong></i>
      </p>
    </div>
  </v-col>
</template>
<script>
export default {
  props: {
    hasPermission: {
      type: Boolean,
      default: false,
    },
    onSidebarFilter: {
      type: Function,
      default: () => {},
    },
    collections: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
img {
  max-width: 230px;
  max-height: 200px;
}
.cursor {
  cursor: pointer;
}
</style>
